import type { LanguageCode } from "config/languages";

export const isDefaultLanguage = (locale: LanguageCode): boolean => (locale ? locale.includes("default") : false);
